export default __webpack_public_path__ + "static/media/rnr-sports-table-11-cn.cfcbe040.webp";